"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utilities_1 = require("../utilities");
class HttpService {
    /**
     * Execute a fetch request
     * @param method
     * @param url
     * @param body
     * @param options
     */
    async fetch(method, url, body, options) {
        const init = {
            method,
            body,
            headers: {},
        };
        // convert the httpOptions to query parameters
        const queryParams = utilities_1.recordToParams(options || {}).join("&");
        const requestUrl = [url, queryParams].join("?");
        // set the base headers
        init.headers = await this.getHeaders(requestUrl, init);
        // clear GET requests and empty bodies from body data since fetch will error
        if (method === "GET" || !init.body) {
            delete init.body;
        }
        // define the type of request
        if (typeof init.body === "object" &&
            init.body instanceof FormData === false) {
            init.headers["Content-Type"] = "application/json";
            init.body = JSON.stringify(init.body);
        }
        // construct and execute the request
        try {
            const response = (await fetch(requestUrl, init));
            // store the actual outcome in response.data
            const dataString = await response.text();
            try {
                response.data = JSON.parse(dataString);
            }
            catch (_a) {
                // catch empty and string responses
                response.data = (dataString || undefined);
            }
            // forward error responses
            if (response.status >= 400) {
                throw response;
            }
            return response;
        }
        catch (error) {
            await this.onRequestError(error);
            throw error;
        }
    }
    /**
     * Execute a POST request.
     * @param url
     * @param body
     */
    post(url, body, options) {
        return this.fetch("POST", url, body, options);
    }
    /**
     * Execute a GET request.
     * @param url
     * @param options
     */
    get(url, options) {
        return this.fetch("GET", url, null, options);
    }
    /**
     * Execute a PUT request.
     * @param url
     * @param body
     */
    put(url, body, options) {
        return this.fetch("PUT", url, body, options);
    }
    /**
     * Execute a PATCH request.
     * @param url
     * @param body
     */
    patch(url, body, options) {
        return this.fetch("PATCH", url, body, options);
    }
    /**
     * Execute a DELETE request
     * @param url
     */
    delete(url, options) {
        return this.fetch("DELETE", url, null, options);
    }
}
exports.HttpService = HttpService;
/**
 * A basic HttpService used as example and out of the box usage.
 */
class SimpleHttpService extends HttpService {
    getHeaders(url, init) {
        return {};
    }
    onRequestError(error) { }
}
exports.SimpleHttpService = SimpleHttpService;
//# sourceMappingURL=http.abstract.service.js.map